import InfoIcon from '@mui/icons-material/Info'
import { Box, IconButton, Typography } from '@mui/material'
import '@xyflow/react/dist/base.css'
import Algo from '../../core/Algo'
import { ISimpleExecutionEnvironment } from '../../definitions/NodesExecution'
import Formatter from '../../helpers/Formatter'
import SmartCard from '../controls/cards/SmartCard'
import { useState } from 'react'
import MinimizeIcon from '@mui/icons-material/Minimize'
import FullscreenIcon from '@mui/icons-material/Fullscreen'

interface P {
    executionEnviroment: ISimpleExecutionEnvironment
    isCompared?: boolean
}

function ExecutionEnvironmentCardInfo({ executionEnviroment, isCompared }: P) {
    const startDate = new Date(executionEnviroment.startedAt)
    const endDate = new Date(executionEnviroment.completedAt)
    const diffMillisec = endDate.getTime() - startDate.getTime()
    const duration = Formatter.timer(Algo.round(diffMillisec / 1000), 'long')
    const [isReduce, setIsReduce] = useState(false)

    const titleMode = () => {
        switch (executionEnviroment.mode) {
            case 'dev': return 'Dev run'
            case 'prod': return 'Real run'
            case 'dry-run': return 'Demo run'
        }
    }

    return (
        <SmartCard style={{ minWidth: 'calc(var(--unit)*30)', opacity: 0.8, padding: 16, borderStyle: isCompared ? 'dashed' : 'solid', border: '2px solid #B388FF' }}>
            <Box display='flex' flexDirection='row' gap={1} justifyContent='space-between'>
                <Box display='flex' flexDirection='row'>
                    <InfoIcon />
                    <Typography marginLeft={0.5} fontWeight={600}>{isCompared ? 'Comparing' : 'Current'} info</Typography>
                </Box>
                <IconButton disableRipple={true} onClick={() => setIsReduce(!isReduce)} sx={{ margin: 0, padding: 0, marginLeft: 1 }}>
                    {isReduce
                        ? <FullscreenIcon fontSize='small' />
                        : <MinimizeIcon fontSize='small' /> }
                </IconButton>
            </Box>
            <Box>
                {!isReduce && (
                    <Box marginTop={1.5}>
                        <Box paddingBottom={1}>
                            <Typography variant='subtitle2' fontWeight={700}>Status:</Typography>
                            <Typography variant='body2'>{executionEnviroment.status}</Typography>
                        </Box>
                        <Box paddingBottom={1}>
                            <Typography variant='subtitle2' fontWeight={700}>Mode:</Typography>
                            <Typography variant='body2'>{titleMode()}</Typography>
                        </Box>
                        <Box paddingBottom={1}>
                            <Typography variant='subtitle2' fontWeight={700}>From - To</Typography>
                            <Typography variant='body2'>{executionEnviroment?.flowRunSetting?.startRunConfig.from} - {executionEnviroment?.flowRunSetting?.startRunConfig.to}</Typography>
                        </Box>
                        <Box paddingBottom={1}>
                            <Typography variant='subtitle2' fontWeight={700}>Time execution:</Typography>
                            <Typography variant='body2'>{duration}</Typography>
                        </Box>
                        <Box>
                            <Typography variant='subtitle2' fontWeight={700}>Execution date:</Typography>
                            <Typography variant='body2'>{Formatter.date(startDate, 'full')}</Typography>
                        </Box>
                        <Box />
                    </Box>
                )}
            </Box>
        </SmartCard>
    )
}

export default ExecutionEnvironmentCardInfo
